export default __webpack_public_path__ + "static/media/safflower.af439405.jpg";